<template>
  <div class="app_container container">
    <div class="entrance-title">浙江干部教育培训数智化管理平台</div>
    <!-- <img class="img" src="../../assets/image/jiaxing/cs.jpeg" /> -->
    <butn
      class="enterBtn"
      btntype="primary"
      title="点击进入"
      @click="enterClick"
    ></butn>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { getLargeScreenAuthUrl } from '@/api/resourceService/index'

export default {
  name: "cockpitEntrance",
  components: {
    butn,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    enterClick() {
      getLargeScreenAuthUrl().then((res) => {
        if (res.code == 0) {
        //   let reg = /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/;
        //   if (reg.test(res.data)) {
            window.open(res.data, "_blank");
          // } else {
          //   this.$message.warning('url检验出错')
          // }
        }
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  flex-direction: column;
  align-items: center;
  .entrance-title {
    padding: 60px 0 40px;
    color: #000;
    font-size: 44px;
  }

  .img {
    width: auto ;
    height: 800px;
  }
  .enterBtn {
    margin-top: 40px;
    width: 160px;
    height: 60px !important;
    font-size: 22px;
  }
}
</style>
